module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Widmung an Marie Thienemann")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In einer Handschrift des Dramas »Germanen und\nRömer«")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Blumen blühen in dem Garten"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nmeines Geistes, kaum entsprossen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund noch sind die kleinen, zarten"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSchmetterlinge Spielgenossen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Schmetterlinge mögen walten,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nbis zu mächt'gen Blätterkronen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nandre Knospen sich gestalten,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndrin die Nachtigallen wohnen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Tief im Grunde keimen Bäume,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWächter in den duft'gen Matten."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nBlumendüfte geben Träume,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nEichenwipfel geben Schatten.")]), _vm._v(" "), _c('p', {
    staticClass: "centersml"
  }, [_vm._v("1882.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page17",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page18",
      "title": "wedi/Konmax"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0